var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "14", height: "15", viewBox: "0 0 14 15", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Account Settings"
    ),
    React.createElement(
      "g",
      { fill: "#FFF", fillRule: "evenodd" },
      React.createElement("path", { d: "M.244 11.286C1.447 9.934 4.03 9 7.022 9c2.97 0 5.538.921 6.753 2.257A7.994 7.994 0 0 1 7 15a7.994 7.994 0 0 1-6.756-3.714z" }),
      React.createElement("circle", { cx: "7", cy: "4", r: "4" })
    )
  );
});